import { setupProfileForm } from './utils'

export let user = null

window.vfQ = window.vfQ || [];

function updateUser(response) {
    if (response?.user) {
        user = response?.user;
        const fullName = `${user.firstname} ${user.lastname}`;
        document.querySelector('body').classList.add('logged-in');

        const urlParams = new URLSearchParams(window.location.search);
        const maHash = urlParams.get('maHash');
        if (urlParams.get('error') === 'Token Invalid') {
            alert(localisationMessages.invalidRegistrationToken);
        }
        if (maHash) {
            $.post('/profile/ma', { maHash }).then(result => {
                if (result?.success) {
                    window.location.href = '/' + currentEnvironment.language + '/profile.php';
                }
            }, response => {
                const errors = Object.entries(response?.responseJSON?.errors || {})
                    .map(([key, errors]) => errors.map(error => error.message))
                    .reduce((arr, messages) => arr.concat(messages), [])
                    .filter(message => message);
                if (errors.length) {
                    alert(errors.join(' \n'));
                }
                window.location.href = '/' + currentEnvironment.language + '/';
            });
            return;
        }
        else if ($('.sign-up-form:visible').length) {
            //redirect away from sign-up page if logged in and no maHash handling needed
            window.location.href = '/' + currentEnvironment.language + '/';
            return;
        }

        const loginModal = $('#loginModal');
        const profileForm = $('.profile-form');
        const profileOptions = {};
        const profileFieldObjects = {};
        const setProfileOptions = () => {
            let queue = Promise.resolve();

            if (Object.keys(profileOptions).length === 0) {
                queue = $.getJSON('/' + currentEnvironment.language + '/profile/options', (options) => {
                    Object.assign(profileOptions, options);
                });
            }

            const optionsMap = {
                countries: 'countryId',
                communities: 'communities',
                formats: 'formats',
                topics: 'topics',
                areasOfWork: 'areaOfWorkId',
                languages: 'language',
            }

            return queue.then(() => {
                for (const [key, options] of Object.entries(profileOptions)) {
                    profileForm.find('[name="' + optionsMap[key] + '"]').each((i, field) => {
                        field = $(field);
                        if (field.hasClass('tomselected')) {
                            return;
                        }

                        const config = {
                            maxOptions: null,
                            valueField: 'id',
                            labelField: 'text',
                            searchField: 'text',
                            options: options || [],
                            create: false,
                            allowEmptyOption: true,
                        };

                        if (field.attr('multiple')) {
                            config.maxItems = null;
                            config.plugins = {
                                remove_button: {
                                    title: 'Remove',
                                    label: '<img src="/assets/img/icons/icon_transparent_remove.svg" alt="X">',
                                },
                            };
                        }

                        const tomObject = new TomSelect(field, config);

                        if (!profileFieldObjects[optionsMap[key]]) {
                            profileFieldObjects[optionsMap[key]] = [];
                        }
                        profileFieldObjects[optionsMap[key]].push(tomObject);
                    });
                }
            });
        };

        const loadProfile = () => {
            return $.getJSON('/profile').then(userProfile => {
                if (userProfile.incomplete) {
                    profileForm.attr('data-mode', 'complete');
                    $('input[name="firstname"]').val(userProfile.firstname);
                    $('input[name="lastname"]').val(userProfile.lastname);
                } else {
                    profileForm.attr('data-mode', 'edit');
                    $('input[name="firstname"]').closest('label').remove();
                    $('input[name="lastname"]').closest('label').remove();
                }

                ['email', 'firstname', 'lastname', 'memberAssociation'].forEach(attr => {
                    const text = (typeof userProfile[attr] === 'object' ? userProfile[attr].name : userProfile[attr]) || '';
                    const el = $('[data-attr="' + attr + '"]');
                    el.text(text);

                    if (!text) {
                        el.parent().remove();
                    }
                });

                if (userProfile.profile) {
                    [
                        'dateOfBirth',
                        'countryId',
                        'language',
                        'areaOfWorkId',
                        'communities',
                        'formats',
                        'topics',
                    ].forEach(name => {
                        let values = userProfile.profile[name];
                        if (['communities', 'formats', 'topics'].includes(name)) {
                            values = (userProfile[name] || []).map(data => data.id);
                        }

                        if (profileFieldObjects[name] && profileFieldObjects[name].length > 0) {
                            profileFieldObjects[name].forEach(tomObject => tomObject.setValue(values));
                        }
                        else {
                            $('[name="' + name + '"]').val(values).trigger('change');
                        }
                    });
                    ['tacAccepted', 'cocAccepted', 'ppAccepted'].forEach(name => {
                        $('[name="' + name + '"]').prop('checked', Boolean(userProfile.profile[name]));
                    });
                }

                if (userProfile.memberAssociation) {
                    profileForm.find('[name="confederation"], [name="memberAssociation"]').each((i, el) => {
                        if (el.classList.contains('tomselected')) {
                            return;
                        }

                        let title = '';

                        switch (el.name) {
                            case 'confederation':
                                title = userProfile.memberAssociation.confederationName;
                                break;

                            case 'memberAssociation':
                                title = userProfile.memberAssociation.name;
                                break;
                        }

                        new TomSelect(el, {
                            valueField: 'id',
                            labelField: 'text',
                            searchField: 'text',
                            options: [{
                                id: 1,
                                text: title || '',
                            }],
                            items: [
                                1,
                            ],
                            create: false,
                        });
                    });
                }
                else {
                    $('fieldset[data-type="association"]').remove();
                }
            });
        };

        const loadingClass = 'loading';
        const prepareProfile = () => {
            profileForm.addClass(loadingClass);
            setupProfileForm();
            setProfileOptions().then(loadProfile).then(() => {
                profileForm.removeClass(loadingClass);
            }).catch(err => {
                console.error(err);
            });
        };

        loginModal.on('show.bs.modal', function () {
            profileForm.addClass(loadingClass);
        });
        loginModal.on('shown.bs.modal', function () {
            prepareProfile();
        });

        if (response.user.incomplete) {
            profileForm.attr('data-mode', 'complete');
        }
        else {
            profileForm.attr('data-mode', 'edit');
        }

        if (profileForm.filter(':visible').length > 0) {
            prepareProfile();
        }
        else if (response.user.incomplete) {
            loginModal.modal('show');
        }

        loginModal.on('click', '.modal-close', (e) => {
            e.preventDefault();
            loginModal.modal('hide');
        });
    }
    else if ($('.profile-form:visible').length) {
        //redirect away from profile page if not logged in
        window.location.href = '/' + currentEnvironment.language + '/';
        return;
    } else {
        window.vfQ.push(() => {
            vf.session.logout();
        });
    }

    if (response?.idToken && window.vfQ) {
        window.vfQ.push(() => {
            vf.session.login.openIdConnect(response?.idToken);
        });
    }

    if (response?.expires) {
        const remainingMilliseconds = response.expires * 1000 - (new Date()).getTime();
        setTimeout(() => {
            fetch('/user/refresh')
                .then(res => res.json())
                .then(updateUser).catch(console.error);
        }, remainingMilliseconds - 10000); // 10 seconds earlier
    }


    // if (user.user_access.learning_platform) {
    //     learningplatformAccess.style.display = 'block'
    // }
}

window.vfQ.push(() => {
    window.vf.$subscribe('login', 'failure', function (errorContext) {
        if (errorContext.error_key === 'login_banned') {
            let duration = '';
            if (errorContext.isPermanent) {
                duration = 'permanently';
            } else {
                const until = new Date(errorContext.endDate);
                duration = 'until '+until.toLocaleString();
            }
            let message = 'You are banned '+duration+'. Reason / Message: '+errorContext.reason;
            bootstrap.showToast({
                delay: 10000,
                body: message,
                toastClass: 'text-bg-danger',
            });
        }
    });
});

fetch('/user/active')
    .then(res => res.json())
    .then(updateUser).catch(console.error);
